export enum PaymentStatusTypes {
	paid = 'paid',
	notPaid = 'not_paid',
}
